export default __webpack_public_path__ + "static/char-s-40-ja-bb1204ebbf1dc87d69dbac3259b746f9.webp";